export default [
  {
    path: '/person/account',
    name: 'PersonAcount',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/setAccount')
  },
  {
    path: '/modify/pwd',
    name: 'PersonPassword',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/setPassword')
  },
  {
    path: '/person/phone',
    name: 'PersonPhone',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/setPhone')
  },
  {
    path: '/modify/phone',
    name: 'ModifyPhone',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/changePhone')
  },
  {
    path: '/person/email',
    name: 'SetEmail',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/setEmail')
  },
  {
    path: '/modify/email',
    name: 'ModifyEmail',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/account/personInfo/modifyEmail')
  }
]
